import React, { useState } from 'react'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import ApiService from '../../../../store/services/ApiService'

import * as companyAPI from '../../../../store/api/company'

import AboutCompanyForm from '../../../../components/Form/FormComponents/AboutCompanyForm'
import ResetAndSaveButtons from '../../../../components/Form/FormComponents/ResetAndSaveButtons'

import translate from '../../../../stabs/errorMessagesTranslations'
import { myCompanyActions, myCompanySelectors } from '../../../../store/ducks/my-company'
import { toast } from 'react-toastify'

const AddAboutCompanyFormContainer = () => {
  const [state, setState] = useState({
    isLoading: false,
    error: null
  })

  const company = useSelector(myCompanySelectors.getMyCompany)

  const dispatch = useDispatch()
  const onSubmit = (values, { setSubmitting }) => {
    setState({ error: null, isLoading: true })

    ApiService
      .fetch(companyAPI.updateMe(values))
      .then(data => {
        setSubmitting(false)
        setState({ error: null, isLoading: false })

        toast.success('Zapisano!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        })

        dispatch(myCompanyActions.fetchMyCompanySuccess(data))
      })
      .catch(error => {
        setSubmitting(false)
        console.log(error)
        console.log(error.details)
        setState({ error: translate('pl', error.details.msg), isLoading: false })
      })
  }

  return (
    <Formik
      initialValues={{
        mission: company.mission,
        aboutUs: company.aboutUs
      }}
      validationSchema={BasicCompanyDataSchema}
      onSubmit={onSubmit}
      render={({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        handleReset,
        isSubmitting,
        touched,
        values
      }) => (
        <form onSubmit={handleSubmit}>
          <AboutCompanyForm
            apiError={state.error}
            errors={errors}
            handleBlur={handleBlur}
            handleChange={handleChange}
            touched={touched}
            values={values}
          />

          <ResetAndSaveButtons
            data-test='ResetAndSaveButtonsOne'
            onClickReset={handleReset}
            disabledSave={isSubmitting}
            isLoadingSave={state.isLoading}
            isClearing={false}
            isSaveSubmitting
          />
        </form>
      )}
    />
  )
}

const BasicCompanyDataSchema = Yup.object().shape({
  mission: Yup.string(),
  aboutUs: Yup.string()
})

export default AddAboutCompanyFormContainer
